/**
 * Menu - Portal layout wrapper
 * 
 * Handles desktop/mobile layouts using shared components.
 * Matches therapist app structure for consistency.
 */
import React, { useState } from "react";
import { Container, Col } from "react-bootstrap";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "./Header";
import DesktopMenu from "./DesktopMenu";
import MobileMenu from "./MobileMenu";
import { disableNativePush } from "@shared/push/nativePush";
import "./Menu.css";

export default function Menu(props) {
  const isDesktop = useMediaQuery("(min-width:900px)");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const logout = async () => {
    // Store app: no more reminders for this patient on this device. Needs the
    // token, so before it goes; a slow or failed call must not block logout.
    await Promise.race([disableNativePush().catch(() => {}), new Promise((resolve) => setTimeout(resolve, 3000))]);
    localStorage.removeItem("access_token");
    window.location.reload();
  };

  const handleBurgerClick = () => {
    setIsMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
  };

  // Desktop layout - matches therapist structure (no container-fluid padding)
  if (isDesktop) {
    return (
      <>
        <Header />
        <DesktopMenu content={props.content} logout={logout} />
      </>
    );
  }

  // Mobile layout - uses shared MobileMenu like therapist
  return (
    <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
      <Header onBurgerClick={handleBurgerClick} />
      <Col className="program-overview">{props.content}</Col>
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={handleMobileMenuClose}
        logout={logout}
      />
    </Container>
  );
}

